import firebase from "firebase/app"
import "firebase/firestore"

var firebaseConfig = {
  apiKey: "AIzaSyBoLnt5UW3TYG_JO2bRQGIcAx3CwSFVCaI",
  authDomain: "addrust-web.firebaseapp.com",
  projectId: "addrust-web",
  storageBucket: "addrust-web.appspot.com",
  messagingSenderId: "834681326474",
  appId: "1:834681326474:web:c179784b0df89438e05673",
  measurementId: "G-3NW587TVEW",
}

firebase.initializeApp(firebaseConfig)

export const db = firebase.firestore()
export default firebase
